<app-state-view class="results-listing" [state]="state">
  <loading-state>
    <app-dots-spinner aria-label="Loading..."></app-dots-spinner>
  </loading-state>
  <empty-state>
    <div class="results-listing__placeholder">
      <mat-icon class="results-listing__placeholder-icon">info</mat-icon>
      <div class="results-listing__placeholder-message">Please enter a search query to perform a search.</div>
    </div>
  </empty-state>
  <error-state>
    <div class="results-listing__placeholder results-listing__placeholder--error">
      <mat-icon class="results-listing__placeholder-icon">warning</mat-icon>
      <div class="results-listing__placeholder-message">
        {{ errorMessage || 'An error occurred performing the search. Please try again later.' }}
      </div>
    </div>
  </error-state>
  <content-state>
    <div class="results-listing__container">
      <div class="results-listing__filter-bar">
        <button #flyingClubPopoverAnchor="satPopoverAnchor" type="button" class="results-listing__filter"
                [satPopoverAnchorFor]="flyingClubFiltersPopover" (click)="flyingClubFiltersPopover.toggle()"
                [class.results-listing__filter--active]="flyingClubPopoverAnchor.isPopoverOpen()">
          Flying Club Filters
          <mat-icon class="results-listing__filter-arrow">keyboard_arrow_down</mat-icon>
        </button>
      </div>
      <div #flyingClubListEl *ngIf="flyingClubs && flyingClubs.length > 0; else placeholder" class="results-listing__list">
        <a class="flying-club-card"
           #flyingClubEl *ngFor="let flyingClub of flyingClubs"
           [class.flying-club-card--active]="flyingClub === activeFlyingClub"
           [routerLink]="['/flyingclub', flyingClub.businessId]"
           (click)="onFlyingClubSelected()"
           (mouseenter)="onFlyingClubHover(flyingClub, true)"
           (mouseleave)="onFlyingClubHover(flyingClub, false)">
          <div class="flying-club-card__type-row">
            <span class="flying-club-card__type">{{ flyingClub.clubType }}</span>
            <span class="flying-club-card__membership" *ngIf="flyingClub.newMembers">Accepting new members</span>
          </div>
          <div class="flying-club-card__main">
            <div class="flying-club-card__content">
              <h2 class="flying-club-card__name">{{ flyingClub.name }}</h2>
              <div class="flying-club-card__body">
                <div class="flying-club-card__text" *ngIf="flyingClub.airportName || flyingClub.airportIdent">
                  <ng-container *ngIf="flyingClub.airportName">{{ flyingClub.airportName }}</ng-container><ng-container *ngIf="flyingClub.airportName && flyingClub.airportIdent"> - </ng-container><ng-container *ngIf="flyingClub.airportIdent">({{ flyingClub.airportIdent }})</ng-container>
                </div>
                <div class="flying-club-card__text" *ngIf="flyingClub.city || flyingClub.stateProvince">
                  {{ flyingClub.city }}<ng-container *ngIf="flyingClub.city && flyingClub.stateProvince">, </ng-container>{{ flyingClub.stateProvince }}
                </div>
                <div class="flying-club-card__text flying-club-card__detail"
                     *ngIf="flyingClub.clubMembers != null || flyingClub.clubAircraft != null">
                  <span *ngIf="flyingClub.clubMembers != null">{{ flyingClub.clubMembers }} members</span>
                  <span *ngIf="flyingClub.clubMembers != null && flyingClub.clubAircraft != null"> &middot; </span>
                  <span *ngIf="flyingClub.clubAircraft != null">{{ flyingClub.clubAircraft }} aircraft</span>
                </div>
              </div>
            </div>
            <div class="flying-club-card__photo" *ngIf="flyingClub.thumbnailPhotoPath">
              <img class="flying-club-card__image" [src]="flyingClub.thumbnailPhotoPath" alt="" />
            </div>
          </div>
        </a>
      </div>
      <mat-paginator
        *ngIf="flyingClubs && flyingClubs.length > 0"
        class="results-listing__pagination"
        [pageIndex]="pageIndex"
        [length]="totalFlyingClubs"
        [pageSize]="pageSize"
        (page)="onPageChanged($event)">
      </mat-paginator>
    </div>
  </content-state>
</app-state-view>

<ng-template #placeholder>
  <div class="results-listing__placeholder">
    <mat-icon class="results-listing__placeholder-icon">info</mat-icon>
    <div class="results-listing__placeholder-message">
      No results found matching your search criteria. Try reducing the number of filters used in the search.
    </div>
  </div>
</ng-template>


<sat-popover #flyingClubFiltersPopover horizontalAlign="start" verticalAlign="below" hasBackdrop>
  <div class="results-listing__popover">
    <app-flying-club-finder-filter-list #flyingClubFilters [query]="query" [compact]="true"
                                        (filtersChange)="onFiltersChanged()">
    </app-flying-club-finder-filter-list>
  </div>
</sat-popover>
